/**
 * Billing API service for Stripe subscription management.
 */

import axios from './axios';

const billingApi = {
  /**
   * Get current user's subscription status
   * @returns {Promise} Subscription data
   */
  getSubscriptionStatus: async () => {
    const response = await axios.get('/billing/me/');
    return response.data;
  },

  /**
   * Create a Stripe Checkout Session for subscription
   * @param {string} planSlug - Optional plan slug (e.g., 'monthly')
   * @returns {Promise} Checkout session data with URL
   */
  createCheckoutSession: async (planSlug = null) => {
    const data = planSlug ? { plan_slug: planSlug } : {};
    const response = await axios.post('/billing/create-checkout-session/', data);
    return response.data;
  },

  /**
   * Create a Stripe Customer Portal Session
   * @returns {Promise} Portal session data with URL
   */
  createPortalSession: async () => {
    const response = await axios.post('/billing/create-portal-session/');
    return response.data;
  },

  /**
   * Create a PaymentIntent for custom payment form
   * @param {string} planSlug - Optional plan slug (e.g., 'monthly')
   * @param {string[]} paymentMethodTypes - Optional array of payment method types
   * @returns {Promise} PaymentIntent data with client_secret
   */
  createPaymentIntent: async (planSlug = null, paymentMethodTypes = null) => {
    const data = {};
    if (planSlug) data.plan_slug = planSlug;
    if (paymentMethodTypes) data.payment_method_types = paymentMethodTypes;
    const response = await axios.post('/billing/create-payment-intent/', data);
    return response.data;
  },
};

export default billingApi;
